
<div class="modal-dialog" style="max-width: 800px;">
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">Key Generator</h4>
      <button class="close" type="button" (click)="cancel()">&times;</button>
    </div>
    <div class="modal-body">
      <p [ngSwitch]="authenticationMechanism"><span *ngSwitchCase="'aws4'">Use the fields below to sign your request using the <a href="https://docs.aws.amazon.com/general/latest/gr/signature-version-4.html">AWS Signature Version 4</a> spec:</span><span *ngSwitchCase="'plain'">Use the headers below in your request:</span><span *ngSwitchDefault>Use the headers below in your request:</span></p>
      <textarea class="form-control" [(ngModel)]="data" name="data" readonly rows="6"></textarea>
    </div>
    <div class="modal-footer">
      <button class="btn btn-primary" type="button" (click)="exit()">Finish</button>
    </div>
  </div>
</div>